export default "__VITE_ASSET__wy8ERhsh__"